import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Button, Icon, Segment, Checkbox } from "semantic-ui-react";
import { toast } from "../../../../../..";
import {
    AddCGMBranch,
    SetCGMInput,
    ToggleCGMTimeIntervals,
} from "../../../../../../actions/cgmBranchesActions";
import { AppState } from "../../../../../../store/configureStore";

interface IProps {
    handleCloseForm: () => void;
    handleRemoveBranch: (key: string, type: string) => void;
    handleCriticalBranchBranchInputChange: (e: any, type: string) => void;
    handleOutageBranchEic: (key: string, val: string) => void;
}

export const CriticalBranchesForm = ({
    handleCloseForm,
    handleRemoveBranch,
    handleCriticalBranchBranchInputChange,
    handleOutageBranchEic,
}: IProps) => {
    const dispatch = useDispatch();
    const { cgmBranch, country } = useSelector((state: AppState) => state.cgmBranches);
    const activeTimestamps = useSelector((state: AppState) => state.timestamps.timestamps);
    const [iMax, setIMax] = useState("imaxA");
    const [permIMax, setPermIMax] = useState("permImaxA");
    const [tempIMax, setTempIMax] = useState("tempImaxA");
    const disabled =
        !cgmBranch.id ||
        !cgmBranch.timeInterval ||
        (cgmBranch.criticalBranch && !cgmBranch.criticalBranch.name) ||
        (iMax === "imaxA" ? !cgmBranch.imaxA : !cgmBranch.imaxFactor) ||
        (permIMax === "permImaxA" ? !cgmBranch.permanentImaxA : !cgmBranch.permanentImaxFactor) ||
        (tempIMax === "tempImaxA" ? !cgmBranch.temporaryImaxA : !cgmBranch.temporaryImaxFactor) ||
        !cgmBranch.frmMw ||
        !cgmBranch.minRamFactor ||
        (cgmBranch.criticalBranch && !cgmBranch.tsoOrigin) ||
        (cgmBranch.outage &&
            cgmBranch.outage.branches.length > 0 &&
            (!cgmBranch.outage.id || !cgmBranch.outage.name || !cgmBranch.outage.location));

    useEffect(() => {
        if (cgmBranch.criticalBranch && cgmBranch.tsoOrigin === "") {
            const e = { target: { name: "tsoOrigin", value: country } };
            dispatch(SetCGMInput(e));
        }
        if (cgmBranch.criticalBranch === undefined) {
            const e = { target: { name: "tsoOrigin", value: "" } };
            dispatch(SetCGMInput(e));
        }
    }, [cgmBranch.criticalBranch, country, cgmBranch.tsoOrigin, dispatch]);

    return (
        <Form id="critical-branch-form">
            <Form.Field id="formField-criticalBranchesForm-a" required>
                <label id="label-criticalBranchesForm-CriticalBranchID">Critical branch ID</label>
                <input
                    id="input-criticalBranchesForm-id-a"
                    name="id"
                    type="text"
                    value={cgmBranch.id}
                    onChange={e => dispatch(SetCGMInput(e))}
                />
            </Form.Field>
            <Form.Field id="formField-criticalBranchesForm-b" required>
                <label id="label-criticalBranchesForm-Timestamps">Timestamps</label>
            </Form.Field>
            <Segment id="segment-criticalBranchesForm-b">
                {activeTimestamps.map(timestamp => (
                    <Checkbox
                        id={`checkbox-criticalBranchesForm-a-${timestamp.key}`}
                        //key={timestamp}
                        key={timestamp.key}
                        className="timestamp-checkbox"
                        //checked={cgmBranch.timeInterval.includes(timestamp)}
                        checked={cgmBranch.timeInterval.includes(timestamp.key)}
                        //checked={cgmBranch.timeInterval.some(e => e === timestamp.key)}
                        //label={timestamp.toString().padStart(2, "0") + ":30"}
                        label={timestamp.text}
                        onClick={() => dispatch(ToggleCGMTimeIntervals(timestamp.key))}
                    />
                ))}
            </Segment>
            {cgmBranch.criticalBranch && (
                <section id="section-criticalBranchesForm-b" className="branch-content">
                    <div id="div-criticalBranchesForm-ba">
                        <p id="p-criticalBranchesForm-criticalBranch">Critical branch:</p>
                        <Form.Field id="formField-criticalBranchesForm-ba" required>
                            <label id="label-criticalBranchesForm-name-a">Name</label>
                            <input
                                id="input-criticalBranchesForm-ba"
                                name="name"
                                type="text"
                                value={cgmBranch.criticalBranch.name}
                                onChange={e => handleCriticalBranchBranchInputChange(e, "cb")}
                            />
                        </Form.Field>
                        <p id="p-criticalBranchesForm-ba">
                            <span id="span-criticalBranchesForm-from">From: </span>
                            {cgmBranch.criticalBranch.node1}
                        </p>
                        <p id="p-criticalBranchesForm-bb">
                            <span id="span-criticalBranchesForm-to">To: </span>
                            {cgmBranch.criticalBranch.node2}
                        </p>
                        <p id="p-criticalBranchesForm-bc">
                            <span id="span-criticalBranchesForm-order">Order: </span>
                            {cgmBranch.criticalBranch.orderCode}
                        </p>
                        <p id="p-criticalBranchesForm-bd">
                            <span id="span-criticalBranchesForm-elementName">Element name: </span>
                            {cgmBranch.criticalBranch.elementName}
                        </p>
                        <Form.Field id="formField-criticalBranchesForm-bc">
                            <label id="label-criticalBranchesForm-EIC">EIC</label>
                            <input
                                id="input-criticalBranchesForm-eic"
                                name="eic"
                                type="text"
                                value={cgmBranch.criticalBranch.eic}
                                onChange={e => handleCriticalBranchBranchInputChange(e, "cb")}
                            />
                        </Form.Field>
                    </div>
                    <Icon
                        id="icon-criticalBranchesForm-delete"
                        onClick={() => handleRemoveBranch(cgmBranch.criticalBranch!.key!, "cb")}
                        name="delete"
                        size="large"
                    />
                </section>
            )}
            <div id="div-criticalBranchesForm-ca" className="critical-branch-form">
                <Form.Select
                    required
                    selectOnBlur={false}
                    id="selectIMax"
                    name="selectIMax"
                    label="IMax"
                    defaultValue="imaxA"
                    options={[
                        { key: "imaxA", text: "IMaxA", value: "imaxA" },
                        {
                            key: "imaxFactor",
                            text: "IMaxFactor",
                            value: "imaxFactor",
                        },
                    ]}
                    onChange={(e, { value }) => setIMax(value!.toString())}
                />
                {iMax === "imaxA" ? (
                    <Form.Field id="formField-criticalBranchesForm-cb" required>
                        <label id="label-criticalBranchesForm-IMaxA">IMaxA</label>
                        <input
                            id="input-criticalBranchesForm-imaxA"
                            name="imaxA"
                            type="text"
                            value={cgmBranch.imaxA || ""}
                            onChange={e => dispatch(SetCGMInput(e))}
                        />
                    </Form.Field>
                ) : (
                    <Form.Field id="formField-criticalBranchesForm-cd" required>
                        <label id="label-criticalBranchesForm-IMaxFactor">IMaxFactor</label>
                        <input
                            id="input-criticalBranchesForm-imaxFactor"
                            name="imaxFactor"
                            type="text"
                            value={cgmBranch.imaxFactor || ""}
                            onChange={e => dispatch(SetCGMInput(e))}
                        />
                    </Form.Field>
                )}
                <Form.Select
                    required
                    selectOnBlur={false}
                    id="selectPermIMax"
                    name="selectPermIMax"
                    label="Permanent IMax"
                    defaultValue="permImaxA"
                    options={[
                        {
                            key: "permImaxA",
                            text: "Permanent IMaxA",
                            value: "permImaxA",
                        },
                        {
                            key: "permImaxFactor",
                            text: "Permanent IMaxFactor",
                            value: "permImaxFactor",
                        },
                    ]}
                    onChange={(e, { value }) => setPermIMax(value!.toString())}
                />
                {permIMax === "permImaxA" ? (
                    <Form.Field id="formField-criticalBranchesForm-ce" required>
                        <label id="label-criticalBranchesForm-permanentIMaxA">Permanent IMaxA</label>
                        <input
                            id="input-criticalBranchesForm-permanentImaxA"
                            name="permanentImaxA"
                            type="text"
                            value={cgmBranch.permanentImaxA || ""}
                            onChange={e => dispatch(SetCGMInput(e))}
                        />
                    </Form.Field>
                ) : (
                    <Form.Field id="formField-criticalBranchesForm-cf" required>
                        <label id="label-criticalBranchesForm-permanentIMaxFactor">Permanent IMaxFactor</label>
                        <input
                            id="input-criticalBranchesForm-permanentImaxFactor"
                            name="permanentImaxFactor"
                            type="text"
                            value={cgmBranch.permanentImaxFactor || ""}
                            onChange={e => dispatch(SetCGMInput(e))}
                        />
                    </Form.Field>
                )}
                <Form.Select
                    required
                    selectOnBlur={false}
                    id="selectTempIMax"
                    name="selectTempIMax"
                    label="Temporary IMax"
                    defaultValue="tempImaxA"
                    options={[
                        {
                            key: "tempImaxA",
                            text: "Temporary IMaxA",
                            value: "tempImaxA",
                        },
                        {
                            key: "tempImaxFactor",
                            text: "Temporary IMaxFactor",
                            value: "tempImaxFactor",
                        },
                    ]}
                    onChange={(e, { value }) => setTempIMax(value!.toString())}
                />
                {tempIMax === "tempImaxA" ? (
                    <Form.Field id="formField-criticalBranchesForm-cg" required>
                        <label id="label-criticalBranchesForm-temporaryIMaxA">Temporary IMaxA</label>
                        <input
                            id="input-criticalBranchesForm-temporaryImaxA"
                            name="temporaryImaxA"
                            type="text"
                            value={cgmBranch.temporaryImaxA || ""}
                            onChange={e => dispatch(SetCGMInput(e))}
                        />
                    </Form.Field>
                ) : (
                    <Form.Field id="formField-criticalBranchesForm-ch" required>
                        <label id="label-criticalBranchesForm-temporaryIMaxFactor">Temporary IMaxFactor</label>
                        <input
                            id="input-criticalBranchesForm-temporaryIMaxFactor"
                            name="temporaryImaxFactor"
                            type="text"
                            value={cgmBranch.temporaryImaxFactor || ""}
                            onChange={e => dispatch(SetCGMInput(e))}
                        />
                    </Form.Field>
                )}
                <Form.Select
                    required
                    selectOnBlur={false}
                    id="imaxType"
                    name="imaxType"
                    label="IMax type"
                    defaultValue="dynamic"
                    options={[
                        {
                            key: "dynamic",
                            text: "Dynamic",
                            value: "dynamic",
                        },
                        {
                            key: "fixed",
                            text: "Fixed",
                            value: "fixed",
                        },
                        {
                            key: "seasonal",
                            text: "Seasonal",
                            value: "seasonal",
                        },
                    ]}
                    onChange={(e, data) => dispatch(SetCGMInput(e, data))}
                />
                <Form.Field id="formField-criticalBranchesForm-da"  required>
                    <label id="label-criticalBranchesForm-FrmMw">FrmMw</label>
                    <input
                        id="input-criticalBranchesForm-frmMw"
                        name="frmMw"
                        type="text"
                        value={cgmBranch.frmMw}
                        onChange={e => dispatch(SetCGMInput(e))}
                    />
                </Form.Field>
                <Form.Field id="formField-criticalBranchesForm-db" required>
                    <label id="label-criticalBranchesForm-MinRamFactor">MinRamFactor</label>
                    <input
                        id="input-criticalBranchesForm-minRamFactor"
                        name="minRamFactor"
                        type="text"
                        value={cgmBranch.minRamFactor}
                        onChange={e => dispatch(SetCGMInput(e))}
                    />
                </Form.Field>
                <Form.Select
                    required
                    selectOnBlur={false}
                    id="direction"
                    name="direction"
                    label="Direction"
                    defaultValue="direct"
                    options={[
                        {
                            key: "direct",
                            text: "Direct",
                            value: "direct",
                        },
                        {
                            key: "opposite",
                            text: "Opposite",
                            value: "opposite",
                        },
                    ]}
                    onChange={(e, data) => dispatch(SetCGMInput(e, data))}
                />
                <Form.Field id="formField-criticalBranchesForm-dc" required>
                    <label id="label-criticalBranchesForm-TSOorigin">TSO origin</label>
                    <input
                        id="input-criticalBranchesForm-tsoOrigin"
                        name="tsoOrigin"
                        type="text"
                        value={cgmBranch.tsoOrigin}
                        onChange={e => dispatch(SetCGMInput(e))}
                    />
                </Form.Field>
                <div id="div-form-checkboxes-criticalBranchesForm">
                    <Form.Checkbox
                        id="cnec"
                        label="CNEC"
                        checked={cgmBranch.cnec}
                        onChange={e => dispatch(SetCGMInput(e))}
                    />
                    <Form.Checkbox
                        id="mnec"
                        label="MNEC"
                        checked={cgmBranch.mnec}
                        onChange={e => dispatch(SetCGMInput(e))}
                    />
                </div>
            </div>
            {cgmBranch.outage!.branches.length > 0 && (
                <div id="div-outages-list-criticalBranchesForm-a" className="outages-list">
                    <p id="p-criticalBranchesForm-outage">Outage:</p>
                    <Form.Field id="formField-criticalBranchesForm-de" required>
                        <label id="label-criticalBranchesForm-ID">ID</label>
                        <input
                            id="input-criticalBranchesForm-id-B"
                            name="id"
                            type="text"
                            value={cgmBranch.outage!.id}
                            onChange={e => handleCriticalBranchBranchInputChange(e, "co")}
                        />
                    </Form.Field>
                    <Form.Field id="formField-criticalBranchesForm-df" required>
                        <label id="label-criticalBranchesForm-name-b">Name</label>
                        <input
                            id="input-criticalBranchesForm-name"
                            name="name"
                            type="text"
                            value={cgmBranch.outage!.name}
                            onChange={e => handleCriticalBranchBranchInputChange(e, "co")}
                        />
                    </Form.Field>
                    <Form.Field id="formField-criticalBranchesForm-dg" required>
                        <label id="label-criticalBranchesForm-location">Location</label>
                        <input
                            id="input-criticalBranchesForm-location"
                            name="location"
                            type="text"
                            value={cgmBranch.outage!.location}
                            onChange={e => handleCriticalBranchBranchInputChange(e, "co")}
                        />
                    </Form.Field>
                    {cgmBranch.outage!.branches.map(l => (
                        <div id={`div-criticalBranchesForm-fa-${l.elementName}`}
                            key={`${l.node1}${l.node2}${l.orderCode}${l.elementName}`}
                            className="branch-content"
                        >
                            <div id={`div-criticalBranchesForm-fb-${l.elementName}`}>
                                <p id={`p-criticalBranchesForm-fb-${l.elementName}`}>
                                    <span id={`span-criticalBranchesForm-from-${l.elementName}`}>From: </span>
                                    {l.node1}
                                </p>
                                <p id={`p-criticalBranchesForm-fc-${l.elementName}`}>
                                    <span id={`span-criticalBranchesForm-to-${l.elementName}`}>To: </span>
                                    {l.node2}
                                </p>
                                <p id={`p-criticalBranchesForm-fd-${l.elementName}`}>
                                    <span id={`span-criticalBranchesForm-order-${l.elementName}`}>Order: </span>
                                    {l.orderCode}
                                </p>
                                <p id={`p-criticalBranchesForm-fe-${l.elementName}`}>
                                    <span id={`span-criticalBranchesForm-elementName-${l.elementName}`}>Element name: </span>
                                    {l.elementName}
                                </p>
                                <Form.Field id={`formField-criticalBranchesForm-fa-${l.elementName}`}>
                                    <label id={`label-criticalBranchesForm-eic-${l.elementName}`}>EIC</label>
                                    <input
                                        id={`input-criticalBranchesForm-eic-b-${l.elementName}`}
                                        name="eic"
                                        type="text"
                                        value={
                                            cgmBranch.outage!.branches.filter(
                                                x => x.key === l.key
                                            )[0].eic
                                        }
                                        onChange={e =>
                                            handleOutageBranchEic(l.key!, e.target.value)
                                        }
                                    />
                                </Form.Field>
                            </div>
                            <Icon
                                id={`icon-criticalBranchesForm-delete-b-${l.elementName}`}
                                onClick={() => handleRemoveBranch(l.key!, "co")}
                                name="delete"
                                size="large"
                            />
                        </div>
                    ))}
                </div>
            )}
            <div id="submit-button-container">
                <Button
                    id="submit"
                    type="submit"
                    onClick={() => {
                        dispatch(AddCGMBranch(cgmBranch));
                        handleCloseForm();
                        toast("Form saved!", true);
                    }}
                    content="Save"
                    primary
                    disabled={disabled}
                />
            </div>
        </Form>
    );
};
